import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import formActions from './form-actions'

/*

Handles form configuration state, on a per page basis. Assumes that only one "form" is present
at a time. The @withForm decorator accepts a form configuration with the following fields:

{
    rules: {},
    predicates:{},
    options:{},
    inferred:{},
    transformOut: data => data
}

This supplied configuration is intended to be accessed by special "smart" components via:

state.form.getData(fields)

The returned value will be a indicitive of the form configuration and the current fields state.

*/

function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        form: state.form
    }
}


function mapDispatchToProps(dispatch, props){
    return {
        actions:{
            ...props.actions,
            form: bindActionCreators(formActions, dispatch)
        }
    }
}


export function withForm(formConfig){

    return function(Wrapped:React.ComponentClass){

        return connect(mapStateToProps, mapDispatchToProps)(class extends React.Component<any, any>{
            
            componentWillMount(){
               console.log("MOUNTED A FORM")
               this.props.actions.form.set( formConfig );
            }

            render(){
                if(this.props.form.getData == null) return null
                else return <Wrapped { ...this.props } />
            }

        })

    } as any // Hacky

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/form/index.tsx